import { c as _c } from "react/compiler-runtime";
import React, { HTMLAttributes, PropsWithChildren, ReactNode } from 'react';
import { resolveAnchorId } from '@/utils/anchors';
import { mergeClasses } from '@/utils/style';
type BaseHeadlineProps = HTMLAttributes<HTMLHeadingElement> & {
  variant?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  className?: string;
  'data-analytics-param'?: string;
};
type H1HeadlineProps = {
  as: 'h1';
  anchorKey: string;
  id?: string;
} | {
  as: 'h1';
  id: string;
  anchorKey?: string;
};
type OtherHeadlineProps = {
  as: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  anchorKey?: string;
  id?: string;
};
type HeadlineProps = PropsWithChildren<BaseHeadlineProps & (H1HeadlineProps | OtherHeadlineProps)>;
const sizes = {
  h1: 'font-bold text-4xl lg:text-[3.25rem] 4xl:text-[4rem] leading-[140%]',
  h2: 'font-bold text-4xl md:text-[3.25rem] leading-[140%]',
  h3: 'font-bold text-[1.625rem] md:text-[2.5rem] leading-[140%]',
  h4: 'font-bold text-xl md:text-[2rem] leading-[140%]',
  h5: 'font-semibold md:font-bold text-base md:text-[1.625rem] leading-[150%] md:leading-[140%]',
  h6: 'font-semibold text-base md:text-xl leading-[150%]'
};
export const Headline = t0 => {
  const $ = _c(23);
  let anchorKey;
  let as;
  let children;
  let className;
  let id;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      as,
      variant: t1,
      className,
      children,
      anchorKey,
      id,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = anchorKey;
    $[2] = as;
    $[3] = children;
    $[4] = className;
    $[5] = id;
    $[6] = props;
    $[7] = t1;
  } else {
    anchorKey = $[1];
    as = $[2];
    children = $[3];
    className = $[4];
    id = $[5];
    props = $[6];
    t1 = $[7];
  }
  const variant = t1 === undefined ? as : t1;
  const sizeClasses = sizes[variant] || sizes[as] || sizes.h1;
  const HeadlineTag = as;
  let t2;
  if ($[8] !== anchorKey || $[9] !== id) {
    t2 = resolveAnchorId(anchorKey, id);
    $[8] = anchorKey;
    $[9] = id;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  const resolvedId = t2;
  const t3 = props["data-analytics-param"] ?? (as === "h2" ? "sectionHeader" : undefined);
  let t4;
  if ($[11] !== t3) {
    t4 = {
      "data-analytics-param": t3
    };
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  const params = t4;
  let t5;
  if ($[13] !== className || $[14] !== sizeClasses) {
    t5 = mergeClasses(sizeClasses, className);
    $[13] = className;
    $[14] = sizeClasses;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== HeadlineTag || $[17] !== children || $[18] !== params || $[19] !== props || $[20] !== resolvedId || $[21] !== t5) {
    t6 = <HeadlineTag id={resolvedId} className={t5} {...props} {...params}>{children}</HeadlineTag>;
    $[16] = HeadlineTag;
    $[17] = children;
    $[18] = params;
    $[19] = props;
    $[20] = resolvedId;
    $[21] = t5;
    $[22] = t6;
  } else {
    t6 = $[22];
  }
  return t6;
};
export default Headline;